import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { PermissionGroupDefinition, PermissionLevel } from './role-permission-groups';
import { RoleGrantsPopoverComponent } from './role-grants-popover';

export interface RolePermissionScopeSummary {
  readonly group: PermissionGroupDefinition;
  readonly level: PermissionLevel;
  readonly grants: readonly string[];
}

@Component({
  selector: 'tf-settings-role-permission-scope',
  imports: [RoleGrantsPopoverComponent, TranslateModule],
  templateUrl: './role-permission-scope.html',
  styleUrl: './role-permission-scope.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolePermissionScopeComponent {
  private readonly translateService = inject(TranslateService);

  readonly summaries = input.required<readonly RolePermissionScopeSummary[]>();
  readonly grantCount = input.required<number>();
  readonly groupCount = input.required<number>();

  permissionBarClass(level: PermissionLevel): string {
    return `permission-scope__bar permission-scope__bar--${level}`;
  }

  levelLabel(level: PermissionLevel): string {
    return this.translateService.instant(`SETTINGS_ACCESS.ROLES.LEVELS.${level.toUpperCase()}`);
  }
}
